<div class="content-container position-relative">
    <div class="d-flex justify-content-center align-items-center loader-container" *ngIf="isTopicLoading">
        <div class="loader-class d-flex flex-column justify-content-center align-items-center text-center">
            <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
            <span>Please wait</span>
        </div>
    </div>

    <div *ngIf="isMobile" style="width: 100%; margin-top: 10px">
        <div class="container">
            <div class="row paddingright">
                <div class="col-sm-12 text-start">
                    <app-breadcrumb [path]="currentTopicPath" (topicBreadcrumbClicked)="onTopicBreadcrumbClick($event)" (allTopicClicked)="showAllSearches()"></app-breadcrumb>
                </div>
            </div>

            <div class="mt-3"></div>

            <div class="d-flex">
                <div class="input-group" style="flex: 1; max-width: 70%">
                    <input
                        type="text"
                        [(ngModel)]="findByNameValue"
                        (input)="onSearchInput(findByNameValue)"
                        placeholder="Keyword Search"
                        class="form-control text-black search-topic-box"
                        [disabled]="!allowSearch"
                        [attr.id]="'go-findByNameValue'"
                        [attr.data-test]="'go-findByNameValue'"
                    />
                </div>

                <div class="text-end d-flex" style="padding-left: 10px !important">
                    <button class="custom-create-gyan-btn" (click)="createGysnBtnClick()" [attr.id]="'go-creategyantbn'" [attr.data-test]="'go-creategyantbn'">
                        <div class="create-gyan-plus-icon"></div>
                        Create Gyan
                    </button>
                    <!-- <span class="createnewgyanbtn">Create Gyan</span> -->
                </div>
            </div>

            <div class="mt-3"></div>

            <div class="d-flex paddingright">
                <div>
                    <app-toggle-dropdown
                        text="Filter"
                        [selectedFilter]="selectedFilter"
                        (filterSelected)="onFilterSelected($event)"
                        iconSrc="../../../../assets/organisation/icon-filter.svg"
                        filterItems="{filterItems}"
                        (findByName)="findByName($event)"
                    ></app-toggle-dropdown>
                </div>

                <div style="margin-left: 10px">
                    <app-toggle-dropdown
                        text="Sort"
                        [selectedFilter]="selectedSort"
                        (sortSelected)="onSortSelected($event)"
                        iconSrc="../../../../assets/organisation/icon-sort.svg"
                    ></app-toggle-dropdown>
                </div>

                <div>
                    <button
                        class="btn btn-custom createFolder"
                        [ngClass]="{ active: isNewFolderActive }"
                        (click)="showFolderPopup(showCreateFolderModal, 'sm')"
                        [attr.id]="'go-createfolderbtn'"
                        [attr.data-test]="'go-createfolderbtn'"
                    >
                        <img
                            *ngIf="isNewFolderActive || isNewFolderHovered"
                            src="../../../../assets/organisation/icon-new-folder-hover-active.svg"
                            alt="Folder Icon"
                            title="Folder Icon"
                            class="icon active"
                        />
                        <img
                            *ngIf="!isNewFolderActive && !isNewFolderHovered"
                            src="../../../../assets/organisation/icon-new-folder.svg"
                            alt="Folder Icon"
                            title="Folder Icon"
                            class="icon inactive"
                        />
                    </button>
                </div>

                <div *ngIf="multiSelected.length > 0" style="margin-left: -10px">
                    <button
                        class="btn btn-custom moveItem"
                        [ngClass]="{ active: isMoveItemActive }"
                        (click)="showMovePopup('', showMoveFolderModal, 'ms')"
                        [attr.id]="'go-multipleMoveGyanbtn'"
                        [attr.data-test]="'go-multipleMoveGyanbtn'"
                    >
                        <img
                            *ngIf="!isMoveItemActive && !isMoveItemHovered"
                            src="../../../../assets/organisation/icon-move-new.svg"
                            alt="Move Icon"
                            title="Move Icon"
                            class="icon active"
                        />
                        <img
                            *ngIf="isMoveItemActive || isMoveItemHovered"
                            src="../../../../assets/organisation/icon-move-new-hover-active.svg"
                            alt="Move Icon"
                            title="Move Icon"
                            class="icon inactive"
                        />
                    </button>
                </div>
            </div>

            <div class="mt-3"></div>

            <div class="searchesList" infiniteScroll [scrollWindow]="false" [alwaysCallback]="true" [immediateCheck]="true" (scrolled)="onScrollDown()">
                <app-topic-outline [isGridView]="isGridView" (selectItemParent)="selectItem($event)" (openMoveModalEvent)="showMovePopup('', showMoveFolderModal, 'ms')">
                </app-topic-outline>
            </div>
        </div>
    </div>

    <div *ngIf="!isMobile" class="d-flex">
        <div class="container">
            <!-- First row with 2 columns -->
            <div class="row">
                <div class="col-md-10 text-start">
                    <app-breadcrumb [path]="currentTopicPath" (topicBreadcrumbClicked)="onTopicBreadcrumbClick($event)" (allTopicClicked)="showAllSearches()"></app-breadcrumb>
                </div>
                <div class="col-md-2 text-end parent-container float-end">
                    <!-- <span class="createnewgyanbtn" (click)="createGysnBtnClick()" [attr.id]="'go-creategyantbn'" [attr.data-test]="'go-creategyantbn'">Create Gyan</span> -->
                    <button class="custom-create-gyan-btn" (click)="createGysnBtnClick()" [attr.id]="'go-creategyantbn'" [attr.data-test]="'go-creategyantbn'">
                        <div class="create-gyan-plus-icon"></div>
                        Create Gyan
                    </button>
                </div>
            </div>

            <div class="mt-3"></div>

            <div class="d-flex align-items-center">
                <div class="input-group" style="max-width: 200px">
                    <input
                        type="text"
                        [(ngModel)]="findByNameValue"
                        (input)="onSearchInput(findByNameValue)"
                        placeholder="Keyword Search"
                        class="form-control text-black search-topic-box"
                        [disabled]="!allowSearch"
                        [attr.id]="'go-findByNameValue'"
                        [attr.data-test]="'go-findByNameValue'"
                    />
                </div>
                <div class="ml-2">
                    <app-toggle-dropdown
                        text="Filter"
                        [selectedFilter]="selectedFilter"
                        (filterSelected)="onFilterSelected($event)"
                        iconSrc="../../../../assets/organisation/icon-filter.svg"
                        filterItems="{filterItems}"
                        (findByName)="findByName($event)"
                    ></app-toggle-dropdown>
                </div>
                <div class="ml-3" style="margin-left: 10px">
                    <app-toggle-dropdown
                        text="Sort"
                        [selectedFilter]="selectedSort"
                        (sortSelected)="onSortSelected($event)"
                        iconSrc="../../../../assets/organisation/icon-sort.svg"
                    ></app-toggle-dropdown>
                </div>

                <div>
                    <button
                        class="btn btn-custom createFolder"
                        [ngClass]="{ active: isNewFolderActive }"
                        (click)="showFolderPopup(showCreateFolderModal, 'sm')"
                        (mouseenter)="onFolderMouseEnter()"
                        (mouseleave)="onFolderMouseLeave()"
                        [attr.id]="'go-createfolderbtn'"
                        [attr.data-test]="'go-createfolderbtn'"
                    >
                        <img
                            *ngIf="isNewFolderActive || isNewFolderHovered"
                            src="../../../../assets/organisation/icon-new-folder-hover-active.svg"
                            alt="Folder Icon"
                            title="Folder Icon"
                            class="icon active"
                        />
                        <img
                            *ngIf="!isNewFolderActive && !isNewFolderHovered"
                            src="../../../../assets/organisation/icon-new-folder.svg"
                            alt="Folder Icon"
                            title="Folder Icon"
                            class="icon inactive"
                        />
                        New Folder
                    </button>
                </div>

                <div *ngIf="multiSelected.length > 0" style="margin-left: -10px">
                    <button
                        class="btn btn-custom moveItem"
                        [ngClass]="{ active: isMoveItemActive }"
                        (click)="showMovePopup('', showMoveFolderModal, 'ms')"
                        (mouseenter)="onMoveMouseEnter()"
                        (mouseleave)="onMoveMouseLeave()"
                        [attr.id]="'go-multipleMoveGyanbtn'"
                        [attr.data-test]="'go-multipleMoveGyanbtn'"
                    >
                        <img
                            *ngIf="!isMoveItemActive && !isMoveItemHovered"
                            src="../../../../assets/organisation/icon-move-new.svg"
                            alt="Move Icon"
                            title="Move Icon"
                            class="icon active"
                        />
                        <img
                            *ngIf="isMoveItemActive || isMoveItemHovered"
                            src="../../../../assets/organisation/icon-move-new-hover-active.svg"
                            alt="Move Icon"
                            title="Move Icon"
                            class="icon inactive"
                        />
                        Move To
                    </button>
                </div>

                <div class="text-end ms-auto">
                    <app-toggle-button (viewChanged)="onViewChanged($event)" [isGridView]="isGridView"></app-toggle-button>
                </div>
            </div>

            <div class="searchesList" infiniteScroll [scrollWindow]="false" [alwaysCallback]="true" [immediateCheck]="true" (scrolled)="onScrollDown()">
                <app-topic-outline
                    [isGridView]="isGridView"
                    (selectItemParent)="selectItem($event)"
                    (moveItem)="moveItem($event)"
                    (openMoveModalEvent)="showMovePopup('', showMoveFolderModal, 'ms')"
                >
                </app-topic-outline>
            </div>
        </div>
    </div>
</div>

<ng-template #showCreateFolderModal let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">New Folder</div>
        <div
            type="button"
            class="gyan-popup-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
            [attr.id]="'go-create-folder-close'"
            [attr.data-test]="'go-create-folder-close'"
        >
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body1 newfolder-container-body">
        <div>
            <div class="my-3 px-0">
                <!-- <label class="inputtitle">Folder Name</label> -->
                <div class="d-flex justify-content-center align-items-center mb-3">
                    <input
                        type="text"
                        [(ngModel)]="newFolderName"
                        placeholder="Name of the Folder"
                        class="form-control folderinput text-black mt-2"
                        [attr.id]="'go-create-folder-input'"
                        [attr.data-test]="'go-create-folder-input'"
                    />
                </div>
                <div *ngIf="showCreateFolderError" class="d-flex mb-3 folder-error">
                    {{ createFolderError }}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button> -->
        <button type="button" class="btn modalactionbtn" (click)="createNewFolder()" [attr.id]="'go-create-folder-create-btn'" [attr.data-test]="'go-create-folder-create-btn'">
            Create
        </button>
        <!-- <button type="button" class="btn btn-primary" (click)="saveFormToLocalStorage(selectedKnowledgeStore.uuid)">Save</button> -->
    </div>
</ng-template>

<ng-template #showMoveFolderModal let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Move To</div>
        <div
            type="button"
            class="gyan-popup-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click'); clearMoveBreadcrumb(); selecteditem = null"
            [attr.id]="'go-move-folder-close'"
            [attr.data-test]="'go-move-folder-close'"
        >
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body1 folder-container-body">
        <div *ngIf="showMoveLoader" class="loader-class">
            <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
            <span>Please wait</span>
        </div>
        <move-breadcrumb class="breadcrumb-header" [path]="currentPath" (breadcrumbClicked)="onBreadcrumbClick($event)" (allClicked)="onAllClick()"></move-breadcrumb>
        <div class="folder-container">
            <app-folder-list [folders]="currentFolders" [displayError]="errorFetchingFolder" (folderClicked)="onFolderClick($event)"></app-folder-list>
        </div>
        <div class="folder-error">
            {{ moveError }}
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modalactionbtn lg" (click)="moveGyan()" [attr.id]="'go-move-folder-move-btn'" [attr.data-test]="'go-move-folder-move-btn'">
            Move Here
        </button>
        <button
            type="button"
            class="btn modalactionbtn"
            (click)="modal.close('Close click'); clearMoveBreadcrumb()"
            [attr.id]="'go-move-folder-cancel-btn'"
            [attr.data-test]="'go-move-folder-cancel-btn'"
        >
            Cancel
        </button>
        <!-- <button type="button" class="btn btn-primary" (click)="saveFormToLocalStorage(selectedKnowledgeStore.uuid)">Save</button> -->
    </div>
</ng-template>

<ng-template #confirmChangesModal let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Confirm</div>
        <div
            type="button"
            class="gyan-popup-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
            [attr.id]="'go-delete-gyan-modal-close'"
            [attr.data-test]="'go-delete-gyan-modal-close'"
        >
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body text-center confirm-text">
        <div>You didn't submit your last Gyan, Do you want to continue with it?</div>
    </div>
    <div class="modal-footer btn-footer mb-2 mt-2">
        <button type="button" class="btn modalactionbtnconfirm" (click)="onConfirmGyan()">Confirm</button>
        <button type="button" class="btn modalactioncancel" (click)="cancelConfirmGyan()">Cancel</button>
    </div>
</ng-template>
